import { magnoliaServiceAPI } from '@/store/api-instance'
import { constants } from '@/constants'
import axios from 'axios'

async function getProgramLoyalty () {
  const res = await magnoliaServiceAPI.get('loyalty/GetProgramLoyalty')
  return res?.data
}

async function getBrandLoyalty () {
  const res = await magnoliaServiceAPI.get('loyalty/GetLoyaltybrands')
  return res?.data
}

async function getLoyaltyResult (dto: any) {
  const idToken = sessionStorage.getItem('id_token')
  const xMarketHeader = (process.env.VUE_APP_MARKET) ? process.env.VUE_APP_MARKET : ''
  const res = await axios.get(constants.api.generalservicev1 + 'shiptos/GetLoyaltyBySapId/' + dto.id + ',' + dto.year, {
    headers: {
      Authorization: idToken,
      'x-market': xMarketHeader
    }
  })
  return res
}

export {
  getLoyaltyResult,
  getProgramLoyalty,
  getBrandLoyalty
}
